import { FieldValues, FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { ProductAndDiscountForm, ChainsAndStatesForm, SummaryForm } from "./";
import { Tabs } from "./Tabs";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ProductAndDiscountValidationSchema, ChainsAndStatesValidationSchema } from "./validation-schema"
import { IRefundRule } from "@refund/query-fixed-discount-rules/contracts";

export function FixedDiscountRuleForm({
  onSubmit,
  defaults,
  isLoading,
  programCode,
  viewMode,
  editMode
}: {
  onSubmit: SubmitHandler<FieldValues>;
  defaults?: IRefundRule;
  isLoading?: boolean;
  programCode?: string;
  viewMode?: boolean;
  editMode?: boolean;
}) {
  const concatenateSchemas = (...schemas) => {
    return schemas.reduce(
      (mergedSchemas, schema) => mergedSchemas.concat(schema),
      yup.object()
    );
  }
  const concatenatedSchemas = concatenateSchemas(
    ProductAndDiscountValidationSchema,
    ChainsAndStatesValidationSchema
  )

  const methods = useForm({
    mode: 'all',
    resolver: yupResolver(
      concatenatedSchemas
    ),
    defaultValues: {
      ...defaults,
    } as any,
  });

  return (
    <FormProvider
      {...methods}
    >
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        className="w-full"
      >
        <Tabs
          tabs={[
            {
              title: "1º Passo",
              text: "Produto e Desconto",
              content: <ProductAndDiscountForm programCode={programCode} defaults={defaults} editMode={editMode} />,
              isDisabled: viewMode
            },
            {
              title: "2º Passo",
              text: "Redes e Estados",
              content: <ChainsAndStatesForm defaults={defaults} editMode={editMode} />,
              isDisabled: viewMode
            },
            {
              title: "3º Passo",
              text: "Resumo",
              content: <SummaryForm defaults={defaults} viewMode={viewMode} editMode={editMode} />,
            }
          ]}
          disableClick={true}
          useMultiStepButton={true}
          multiStepButtonProps={{
            buttonCustomize: {
              formDataValues: methods.getValues,
              forwardButtonCustomize: {
                yupSchemaValidationArray: [
                  ProductAndDiscountValidationSchema,
                  ChainsAndStatesValidationSchema
                ]
              },
              submitButtonCustomize: {
                isDisabled: isLoading,
                yupSchemaValidationConcatened: concatenatedSchemas
              }
            },
            generateExitButton: true,
            generateSubmitButton: !viewMode,
          }}
        />
      </form>
    </FormProvider>
  )
}